import axiosInstance from "../../axios/axiosInstance";
import { CATEGORY_LISTING_PAGINATE, CREATE_MANUFACTURER, MANUFACTURER_DELETE, MANUFACTURER_LISTING_PAGINATE, MANUFACTURER_LISTING_VENDOR_PANEL, MANUFACTURER_SINGLE_LISTING, REGISTER_VENDOR, ROLES_PAGINATE, STATUS_UPDATE_TIMING, STORE_DETAILS_LISTING, SUB_CATEGORY_DETAILS, SUB_CATEGORY_LISTING_PAGINATE, UPDATE_MANUFACTURER, VERIFY_VENDOR } from "../../constants";

export const createManufacturer = (props) => onResponse => {

    try {
        axiosInstance.post(CREATE_MANUFACTURER, props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};

export const verifyVendor = (props) => onResponse => {

    try {
        axiosInstance.post(VERIFY_VENDOR, props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};

export const registerVendor = (props) => onResponse => {

    try {
        axiosInstance.post(REGISTER_VENDOR, props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};

export const updateManufacturer = (props) => onResponse => {
    try {
        axiosInstance.post(UPDATE_MANUFACTURER, props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};

export const getAllManufactures = (props) => onResponse => {
    try {
        let BASE_URL = MANUFACTURER_LISTING_VENDOR_PANEL
        axiosInstance.post(BASE_URL, props)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};



export const getManufacturesListing = () => onResponse => {
    try {
        axiosInstance.post(MANUFACTURER_LISTING_VENDOR_PANEL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getManufacturesListingPaginate = (props) => onResponse => {
    try {

        let BASE_URL = MANUFACTURER_LISTING_PAGINATE + '?';
        if (props?.page) {
            BASE_URL += 'page=' + props?.page + '&'
        }
        if (props?.limit) {
            BASE_URL += 'pageSize=' + props?.limit + '&'
        }

        BASE_URL += 'search=' + props?.search ?? '' + '&'

        axiosInstance.get(BASE_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getRolesPaginate = (props) => onResponse => {
    try {

        let BASE_URL = ROLES_PAGINATE + '?';
        if (props?.page) {
            BASE_URL += 'page=' + props?.page + '&'
        }
        if (props?.limit) {
            BASE_URL += 'pageSize=' + props?.limit + '&'
        }

        BASE_URL += 'search=' + props?.search ?? '' + '&'

        axiosInstance.get(BASE_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getCategoryListingPaginate = (props) => onResponse => {
    try {

        let BASE_URL = CATEGORY_LISTING_PAGINATE + '?';
        if (props?.page) {
            BASE_URL += 'page=' + props?.page + '&'
        }
        if (props?.limit) {
            BASE_URL += 'pageSize=' + props?.limit + '&'
        }

        BASE_URL += 'search=' + props?.search ?? '' + '&'

        axiosInstance.get(BASE_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};


export const getSubCategoryListingPaginate = (props) => onResponse => {
    try {

        let BASE_URL = SUB_CATEGORY_LISTING_PAGINATE;
        // if (props?.page) {
        //     BASE_URL += 'page=' + props?.page + '&'
        // }
        // if (props?.limit) {
        //     BASE_URL += 'pageSize=' + props?.limit + '&'
        // }
        // if (props?.categoryId) {
        //     BASE_URL += 'categoryId=' + props?.categoryId + '&'
        // }

        // BASE_URL += 'search=' + props?.search ?? '' + '&'

        axiosInstance.post(BASE_URL, props)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};

export const getSubCategoryDetails = (id) => (onResponse) => {
    try {
      axiosInstance
        .get(SUB_CATEGORY_DETAILS + id)
        .then((response) => {
          onResponse(response);
        })
        .catch((err) => {
          onResponse(err.response);
        });
    } catch (error) {}
  };



export const getManufacturerDetails = (id) => onResponse => {
    try {
        axiosInstance.get(MANUFACTURER_SINGLE_LISTING + id)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};

export const deleteManufacture = (id) => onResponse => {

    try {
        axiosInstance.delete(MANUFACTURER_DELETE, { data: { manufactureId: id } })
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};

export const getStoresListing = () => onResponse => {
    try {
        axiosInstance.get(STORE_DETAILS_LISTING)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err);
            });

    } catch (error) {

    }

};



export const statusUpdateTiming = (props) => onResponse => {

    try {
        axiosInstance.post(STATUS_UPDATE_TIMING, props)
            .then((response) => {
                onResponse(response);
            })
            .catch((err) => {
                onResponse(err.response);
            });

    } catch (error) {

    }
};